import { UseNavigateResult } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { Link, TableActionsWithIcons, TableActionsWithIconsItem, Tooltip } from 'ui/components'
import { CheckMark } from 'ui/components/CheckMark'
import { DateTime } from 'ui/components/DateTime'
import { IconName } from 'ui/components/Icon'
import { TableColumn } from 'ui/components/Table'
import { DocTemplateListItem } from '~bank-document-templates/types'

export const columns = ({
  navigate,
  onStatusChange
}: {
  navigate: UseNavigateResult<any>
  onStatusChange: ({ id, active }: { id: number; active: boolean }) => void
}): TableColumn<DocTemplateListItem>[] => [
  {
    title: 'Document',
    align: 'left',
    sortable: true,
    key: 'name',
    render: ({ name, id }) => (
      <Link to={routes.bank.documentTemplates.details} params={{ id: id.toString() }}>
        {name}
      </Link>
    )
  },
  {
    title: 'Active',
    render: ({ active }) => <CheckMark value={active} rounded />
  },
  {
    title: 'Internal',
    render: ({ internal }) => <CheckMark value={internal} rounded />
  },
  {
    title: 'Type',
    align: 'left',
    render: ({ type }) => type
  },
  {
    title: 'Level',
    align: 'left',
    render: ({ level }) => level
  },
  {
    title: 'State(s)',
    align: 'center',
    width: '80px',
    render: ({ states, id }) => {
      const list = states.split(',').map((el) => el.trim())

      return (
        <>
          {list.length <= 2 ? (
            states
          ) : (
            <Tooltip
              id={`states-${id}`}
              type="dark"
              event="hover"
              content={<div style={{ maxWidth: 300 }}>{states}</div>}
            >
              <span>{`${list[0]}, ${list[1]}...`}</span>
            </Tooltip>
          )}
        </>
      )
    }
  },
  {
    title: 'Created at',
    align: 'left',
    render: ({ createdAt }) => <DateTime date={createdAt} withTime />
  },
  {
    title: 'Updated at',
    align: 'left',
    render: ({ updatedAt }) => <DateTime date={updatedAt} withTime />
  },
  {
    title: 'Actions',
    align: 'center',
    width: '50px',
    render: ({ id, canActivate, canDeactivate, active }) => {
      const items: TableActionsWithIconsItem[] = [
        {
          type: 'edit',
          onClick: () => navigate({ to: routes.bank.documentTemplates.manage, params: { id: id.toString() } })
        },
        {
          type: 'option',
          title: 'Duplicate',
          icon: IconName.COPY,
          color: 'neutral',
          onClick: () =>
            navigate({ to: routes.bank.documentTemplates.manage, params: { id: '0' }, search: { copyFrom: id } })
        }
      ]

      canActivate &&
        items.push({
          type: 'option',
          title: 'Activate',
          icon: IconName.ACTIVATE,
          color: 'neutral',
          onClick: () => onStatusChange({ id, active })
        })

      canDeactivate &&
        items.push({
          type: 'option',
          title: 'Deactivate',
          icon: IconName.SNOWFLAKE,
          color: 'neutral',
          onClick: () => onStatusChange({ id, active })
        })

      return <TableActionsWithIcons items={items} />
    }
  }
]
